import { HeadingOneText } from '@mint/ui';
import styled from 'styled-components';

export const AdminModalHeading = styled(HeadingOneText)`
  font-size: 1.6rem;
  letter-spacing: normal;
`;
